// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2FYAc","header":"MessagesList_header__1as5_","chat":"MessagesList_chat___Xqt1"};